import ReactCountryFlag from "react-country-flag";
import { Box, Tooltip, useTheme } from "@mui/material";
import { ScheduleEventMeetingItemDto } from "./SchedulePage";
import { GroupKeyType } from "@sis/react-library/ListContainer/ListContainer";
import { getCountryCodeForFlag } from "../../../utils/commonUtils";
import { eventStatusCodes, eventStatusDesc } from "../../shared/commonConstants";
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';

interface ScheduleMeetingItemProps {
    meetingId: GroupKeyType;
    eventMeetings: ScheduleEventMeetingItemDto[]
}

export const ScheduleMeetingItem = ({
    meetingId, eventMeetings
}: ScheduleMeetingItemProps) => {

    const theme = useTheme();

    const eventMeeting = eventMeetings.find(e => e.meetingId === meetingId);
    const countryCode = eventMeeting?.country ?
        getCountryCodeForFlag(eventMeeting.country) :
        undefined;

    const warningStatuses = [eventStatusCodes.Void, eventStatusCodes.Abandon];
    const showWarning = warningStatuses.includes(eventMeeting?.meetingStatus ?? '');

    const warningMessage = `Meeting has been ${eventStatusDesc(eventMeeting?.meetingStatus ?? '')}`;

    return (
        <Box sx={{ display: 'flex' }}>
            {eventMeeting &&
                <>
                    {countryCode &&
                        <ReactCountryFlag
                            countryCode={countryCode} svg
                            style={{ fontSize: '20px', marginRight: '8px' }}
                        />
                    }
                    {eventMeeting.meetingDescription}
                    {showWarning &&
                        <Tooltip
                            title={warningMessage} arrow placement="top" 
                            slotProps={{tooltip: {sx: {backgroundColor:theme.palette.grey[500]}}}}
                        >
                            <Box sx={{ paddingLeft: '10px' }}>
                                <DoNotDisturbAltIcon sx={{ fontSize: "14px", color: theme.palette.error.light }} />
                            </Box>
                        </Tooltip>
                    }
                </>
            }
        </Box>
    )
}
